/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetorchestratorv2FileType } from '../models/Targetorchestratorv2FileType';
import { V1DataProduct } from '../models/V1DataProduct';
import { V1DataSource } from '../models/V1DataSource';
import { V2TargetStatus } from '../models/V2TargetStatus';
import { HttpFile } from '../http/http';

export class V1TargetSearch {
    'id'?: string;
    'orgId'?: string;
    'status'?: V2TargetStatus;
    'fileType'?: Targetorchestratorv2FileType;
    'refId'?: string;
    'folder'?: string;
    'dataProduct'?: V1DataProduct;
    'dataSources'?: Array<V1DataSource>;
    'orgName'?: string;
    'orgLogo'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V2TargetStatus",
            "format": ""
        },
        {
            "name": "fileType",
            "baseName": "file_type",
            "type": "Targetorchestratorv2FileType",
            "format": ""
        },
        {
            "name": "refId",
            "baseName": "ref_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "folder",
            "baseName": "folder",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataProduct",
            "baseName": "data_product",
            "type": "V1DataProduct",
            "format": ""
        },
        {
            "name": "dataSources",
            "baseName": "data_sources",
            "type": "Array<V1DataSource>",
            "format": ""
        },
        {
            "name": "orgName",
            "baseName": "org_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgLogo",
            "baseName": "org_logo",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1TargetSearch.attributeTypeMap;
    }

    public constructor() {
    }
}

